<template>
    <div v-if="show"
        class="fixed z-10 inset-0 bg-gray-900 bg-opacity-60 overflow-y-auto flex items-center justify-center text-base">
        <div class="bg-white rounded-lg shadow-xl w-3/12 h-[36vh]">
            <div class="flex items-center justify-between p-4 border-b">
                <h4 class="text-lg text-gray-800 font-bold">Create Patient Visit</h4>
                <button type="button"
                    class="ml-auto -mx-1.5 -my-1.5 p-1.5 inline-flex text-gray-500 items-center justify-end h-8 w-8 hover:text-custom-yellow"
                    @click="$emit('close')" aria-label="Close">
                    <span class="sr-only">Dismiss</span>
                    <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 14 14">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                    </svg>
                </button>
            </div>

            <div class="flex">
                <div class="ms-4">select visit type a new visit for {{ patient.fullName }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CreatePatientVisitModal',
    props: {
        formData: {
            type: Object,
            required: true,
        },
        patient: {
            type: Object,
            required: true,
        },
        show: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            patientRegForm: { ...this.formData },
        }
    },
    methods: {
        updateForm() {
            this.$emit("update:formData", this.patientRegForm);
            console.log(this.patientRegForm); // Emit updated form data to parent
        },
    },
}
</script>